import Rules from './Rules.container';

export default Rules;
